<template lang="pug">
  base-content(title="NEOJAPAN 申請書PDF作成")
    .columns.has-text-centered
      .column.is-three-fifths.is-offset-one-fifth
        //section.section.has-text-centered
        .content
          p 本サイトは株式会社ネオジャパンのプロダクト製品の発注・申し込み手続き時に必要となる申請書PDFを作成しダウンロードするものです。
          p 各パートナー様のご発注書とは別に必要な書類となりますため、必ず手続き時には発注書と合わせてご発注先へ本申請書も送付いただけますようお願い致します。

    .columns.features.has-text-centered
      .column.is-6
        .card.is-shady
          .card-image.has-text-centered.is-size-1
            i.fa.fa-id-card-alt
          .card-content
            .content
              p.title パートナー様はこちら
              p
                router-link.button.is-main-link.is-medium(data-testid="partner-link", :to="{name: 'partner'}")
                  span.has-text-weight-bold 申請書を選択する
                  b-icon(icon="chevron-circle-right")

      .column.is-6
        .card.is-shady
          .card-image.has-text-centered.is-size-1
            i.fa.fa-users
          .card-content
            .content
              p.title エンドユーザー様はこちら
              p
                router-link.button.is-main-link.is-medium(data-testid="enduser-link", :to="{name: 'enduser'}")
                  span.has-text-weight-bold 申請書を選択する
                  b-icon(icon="chevron-circle-right")
</template>

<script>
import BaseContent from '@/components/BaseContent'
export default {
  name: 'Home',
  components: { BaseContent }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Home.vue